import { get } from 'lodash'
import { HOURS_BANNER_DINELATE, STORE_HOURS_DIFFER } from '../../constants'
import { Description, ParsedOpeningHourWithStatus, HourStatus } from './types'

export function getNonBannerDescription(
  storeDescription: Description | undefined,
  parsedCentreHour: ParsedOpeningHourWithStatus | undefined,
  defaultDescription: string,
  useCentrePrefix?: boolean
): Description {
  const centreDescriptionMaybeDineTillLate = parsedCentreHour
    ? parsedCentreHour.text.description
    : ''
  // This is a hack to deal with already parsed data instead of an
  // intermediate form. To be remove when refactoring.
  const centreDescription =
    centreDescriptionMaybeDineTillLate === HOURS_BANNER_DINELATE
      ? ''
      : centreDescriptionMaybeDineTillLate
  const prefix =
    useCentrePrefix && parsedCentreHour
      ? {
          [HourStatus.Closed]: 'Centre closed',
          [HourStatus.Overnight]: 'Centre open late',
          [HourStatus.Multiple]: 'Centre hours differ',
          [HourStatus.Normal]: '',
        }[parsedCentreHour.status]
      : ''

  const infix = get(storeDescription, 'description') || centreDescription
  const withoutSuffix = `${prefix}${prefix && infix ? ': ' : ''}${infix}`
  const newDescription = withoutSuffix
    ? `${withoutSuffix} ${STORE_HOURS_DIFFER}`
    : ''
  return {
    isColored: Boolean(newDescription),
    description: newDescription || defaultDescription,
  }
}
